import { NgModule } from '@angular/core';
import { CircleAlert, CircleCheck, Info, LucideAngularModule, X } from 'lucide-angular';

const lucide = LucideAngularModule.pick({ CircleCheck, CircleAlert, Info, X });

@NgModule({
  imports: [lucide],
  exports: [LucideAngularModule],
})
export class AppToastIconsModule {}
